import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { logout, setUser } from "../redux/slices/authSlice"; // Hàm logout bạn đã viết
const API_BASE_URL = "https://tourvn.runasp.net/api";

// ⚠️ Tạo biến lưu store, ban đầu là null
let reduxStore = null;

// ✅ Hàm để inject store từ bên ngoài
export const injectStore = (_store) => {
  reduxStore = _store;
};

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Biến kiểm soát trạng thái refresh token
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (token) {
      prom.resolve();
    } else {
      prom.reject(error);
    }
  });
  failedQueue = [];
};

// Interceptor cho Response
axiosInstance.interceptors.response.use(
  (response) => response, // Nếu thành công thì trả về bình thường
  async (error) => {
    const originalRequest = error.config;
    // Nếu là lỗi 401 từ API Login -> Không gọi refresh token, chỉ trả lỗi
    if (!error.response) {
      console.error("Lỗi kết nối đến server!");
      window.location.href = "/error-500";
      return Promise.reject(new Error("Không thể kết nối đến máy chủ!"));
    }
    if (
      error.response?.status === 401 &&
      originalRequest.url.includes("/auths/login")
    ) {
      return Promise.reject(error);
    }
    // 🛑 Xử lý lỗi 403: Điều hướng đến trang mong muốn
    // 🛑 Kiểm tra mã lỗi 403
    if (error.response?.status === 403) {
      // 📌 Trường hợp 1: Refresh Token hết hạn -> Chuyển hướng đăng nhập
      if (originalRequest.url.includes("/auths/refresh-token")) {
        //const { store } = await import("../redux/store");
        //store.dispatch(logout());
        window.location.href = "/login"; // Điều hướng đăng nhập lại
      }
      // 📌 Trường hợp 2: Người dùng truy cập vào trang không có quyền -> Chuyển hướng trang 403
      else {
        window.location.href = "/error-403";
      }
    }
    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(() => {
            return axiosInstance(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const persistedAuth = localStorage.getItem("persist:root");
        let token = persistedAuth
          ? JSON.parse(JSON.parse(persistedAuth).auth)?.user
          : null;
        if (!token) {
          processQueue(new Error("User not found")); // Xử lý hàng đợi trước khi rời trang
          window.location.href = "/login";
          return;
        }
        const decoded = jwtDecode(token);
        const userId = decoded["sub"];
        const response = await axiosInstance.post(
          `/auths/refresh-token?userId=${userId}`
        );
        const newAccessToken = response.data.accessToken; // ← lấy từ response
        // Cập nhật lại Redux state
        //const { store } = await import("../redux/store");
        reduxStore?.dispatch(setUser(newAccessToken));

        // Sau khi refresh thành công, tiếp tục các request đang chờ
        processQueue(null);
        isRefreshing = false;

        return axiosInstance(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError);
        isRefreshing = false;
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
